import { animate, state, style, transition, trigger } from '@angular/animations';
import { DataSource } from '@angular/cdk/collections';
import { AfterViewInit, ChangeDetectorRef, Component, Input, OnDestroy, OnInit, ViewChild, ViewChildren } from '@angular/core';
import { NgForm } from '@angular/forms';
import { MatDialog, MatSort, Sort } from '@angular/material';
import { ActivatedRoute, Router } from '@angular/router';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { ToastrService } from 'ngx-toastr';
import { BehaviorSubject, merge, Observable, Subscription } from 'rxjs';
import { tap } from 'rxjs/operators';
import { Message } from 'src/app/core/class/message';
import { EnumDownloadMenuName } from 'src/app/core/constants/common';
import { EnumContractStatus } from 'src/app/core/constants/contract';
import { ErrorCode } from 'src/app/core/constants/error-code';
import { SCREEN_SIZE } from 'src/app/core/constants/screen-size';
import { CommonService } from 'src/app/core/services/common.service';
import { DocumentMohaService } from 'src/app/core/services/document-moha.service';
import { MultiDownloadService } from 'src/app/core/services/multi-download.service';
import { NotificationService } from 'src/app/core/services/notification.service';
import { ProcessingService } from 'src/app/core/services/processing.service';
import { ResponsiveService } from 'src/app/core/services/responsive.service';
import { BaseComponent } from 'src/app/shared/components/base/base.component';
import { CdkDetailRowDirective } from 'src/app/shared/directive/cdk-detail-row.directive';
import { ForwardContractDialogComponent } from '../../forward-contract-dialog/forward-contract-dialog.component';
import { LaborProfileDialogComponent } from '../labor-profile-dialog/labor-profile-dialog.component';

@Component({
  selector: 'app-view-employee-list',
  templateUrl: './view-employee-list.component.html',
  styleUrls: ['./view-employee-list.component.scss'],
  animations: [
    trigger('detailExpand', [
      state('void', style({ height: '0px', minHeight: '0', visibility: 'hidden' })),
      state('*', style({ height: '*', visibility: 'visible' })),
      transition('void <=> *', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ],
})
export class ViewEmployeeListComponent extends BaseComponent implements OnInit, AfterViewInit, OnDestroy {
  /**
    * Check status of document for process update
    */
  @BlockUI() blockUI: NgBlockUI;
  private dialogRef: any;
  public mediaBreakpoint: any;
  public subscribeMediaBreakPointService: Subscription;
  public SCREEN_SIZE = SCREEN_SIZE;

  constructor(
    private documentMohaService: DocumentMohaService,
    private dialog: MatDialog,
    private notificationService: NotificationService,
    public commonService: CommonService,
    public message: Message,
    private toastr: ToastrService,
    private router: Router,
    private route: ActivatedRoute,
    private responsiveService: ResponsiveService,
    private processingService: ProcessingService,
    private downloadService: MultiDownloadService,
    private cdr: ChangeDetectorRef,
  ) {
    super(commonService, message);
    this.paginate = {
      currentPage: 0,
      pageSize: 10,
      totalRow: 0,
      totalPage: 0,
      totalPageArray: [],
      no: []
    };
  }

  displayedColumns: string[] = [];

  columnDefinitions = [
    { def: 'STT', default: true, showXS: true, showSM: true, showMD: true, name: '', check: true },
    { def: 'fullName', default: true, showXS: true, showSM: true, showMD: true, name: 'headertable.contract_parties', check: true },
    { def: 'certificateNo', default: true, showXS: true, showSM: true, showMD: true, name: 'headertable.contract_parties', check: true },
    { def: 'sex', default: true, showXS: true, showSM: true, showMD: true, name: 'headertable.contract_parties_email', check: true },
    { def: 'email', default: true, showXS: true, showSM: true, showMD: true, name: 'form.service_type', check: true },
    { def: 'phone', default: true, showXS: true, showSM: true, showMD: true, name: 'enterprise_contract.table_headers.document_status', check: true },
    { def: 'action', default: true, showXS: true, showSM: true, showMD: true, name: '', check: true },

  ];
  tableWidth = 1250;

  enumContractStatus = EnumContractStatus;
  documents = {
    certificateNo: '',
    emailOrPhoneOrName: ''
  };
  checkAll: boolean;
  dataSelected: Map<string, Document> = new Map<string, Document>();

  public selected: number = 0;
  dataSource: DocumentDataSource;
  paginate: Paginate;

  oldData = this.documents;
  isFirstLoad = true;
  subscriptions: Subscription = new Subscription();
  @ViewChild(MatSort, { static: false }) sort: MatSort;
  @ViewChild('myForm', { static: false }) ngForm: NgForm;
  @ViewChildren('focusInput') focusInput;

  sortDirection = 'ASC';
  sortColumn = 'name';
  timeOut: any;
  error = '';
  subscription: Subscription;
  expanded = [];
  openedRow: CdkDetailRowDirective;
  parentDocuments: Document[];
  enterpriseId: string;

  @Input() singleChildRowDetail: boolean;

  ngOnInit() {
    this.getDisplayedColumns();
    this.enterpriseId = localStorage.getItem('enterpriseId');
    this.dataSource = new DocumentDataSource();
    this.loadData();
    this.notificationService.subscribeErrorService();
    // reset errorCode
    this.notificationService.resetErrorCode();
    // subscribe errorCode
    this.notificationService.getErrorCode().subscribe(errorCode => {
      if (errorCode === ErrorCode.NoAccessToContracts) {
        if (this.dialogRef) {
          this.dialogRef.close();
        }
        this.toastr.error(this.message.getMessage('messages.contract_processed'));
        this.loadData();
      }
      if (errorCode === ErrorCode.ContractProcessed) {
        if (this.dialogRef) {
          this.dialogRef.close();
        }
        this.loadData();
      }
    });

    window.scrollTo(0, 0);
  }

  changeWidthTable() {
    const check = this.columnDefinitions.filter(item => item.default === true);

    if (this.mediaBreakpoint === SCREEN_SIZE.MD) {
      this.tableWidth = 1650;
    } else {
      let tableWidth;
      if (check.length === 9 || check.length === 10) {
        tableWidth = 950;
      } else if (check.length > 10) {
        tableWidth = 1650;
      }
      this.tableWidth = tableWidth;
    }
  }

  getDisplayedColumns() {
    if (this.mediaBreakpoint === SCREEN_SIZE.XS || this.mediaBreakpoint === SCREEN_SIZE.SM) {
      this.displayedColumns = this.columnDefinitions
        .filter(cd => cd.showXS)
        .map(cd => cd.def);
      this.tableWidth = 300;
    } else {
      if (this.mediaBreakpoint === SCREEN_SIZE.MD) {
        this.displayedColumns = this.columnDefinitions
          .filter(cd => cd.showMD && cd.default)
          .map(cd => cd.def);
      } else {
        this.displayedColumns = this.columnDefinitions.filter(cd => cd.default).map(cd => cd.def);
      }
      this.changeWidthTable();
    }
  }

  ngAfterViewInit(page: number = 0) {
    setTimeout(_ => this.focusInput.first.nativeElement.focus());
    merge(this.sort.sortChange, page)
      .pipe(
        tap(() => this.onFilterData(this.paginate.currentPage, this.paginate.pageSize))
      )
      .subscribe();

    this.subscribeMediaBreakPointService = this.responsiveService._getMediaBreakpoint().subscribe(
      media => {
        if (media === '') {
          this.mediaBreakpoint = '';
          return;
        } else {
          this.mediaBreakpoint = media;
          this.getDisplayedColumns();
        }
      }
    );
  }

  ngOnDestroy() {
    this.notificationService.unsubscribeErrorService();
    this.subscribeMediaBreakPointService.unsubscribe();
    this.downloadService.clearData();
  }
  getFilterCondition(page: number, pageSize: number, data: any): any {
    const {
      certificateNo,
      emailOrPhoneOrName
    } = data;
    let filterCondition: any = {
      certificateNo: certificateNo,
      emailOrPhoneOrName: emailOrPhoneOrName,
      page,
      pageSize,
    };

    let sortColumn = null;
    let sortDirection = null;

    sortDirection = this.sortDirection;
    sortColumn = this.sortColumn; // is searching in parent

    let column = null;
    switch (sortColumn) {
      case 'name':
        column = {
          contractName: sortDirection
        };
        break;
      case 'createdTime':
        column = {
          createdTime: sortDirection
        };
        break;
    }

    filterCondition.sorts = column;

    return filterCondition;
  }

  onToggleChange(cdkDetailRow: CdkDetailRowDirective, row): void {
    if (this.singleChildRowDetail && this.openedRow && this.openedRow.expended) {
      this.openedRow.toggle();
    }

    if (!row.close) {
      row.close = true;
    } else {
      row.close = false;
    }
    this.openedRow = cdkDetailRow.expended ? cdkDetailRow : undefined;
  }

  /**
   * Count record to show
   */
  counter(index: number, from: number): any {
    return new Array(index).fill(0).map((x, i) => i + from);
  }

  /**
   * Get data when init
   */
  loadData(page: number = 0, pageSize: number = 10) {
    let paramCertificateNo: '';
    let paramEmailOrPhoneOrName: '';
    this.subscription = this.route
      .queryParams
      .subscribe(params => {
        paramCertificateNo = params.certificateNo;
        paramEmailOrPhoneOrName = params.emailOrPhoneOrName;
        page = params.page || 0;
        pageSize = params.pageSize && params.pageSize > 0 ? params.pageSize : 10;
        this.sortColumn = params.sortColumn != null ? params.sortColumn : null;
        this.sortDirection = params.sortDirection != null ? params.sortDirection : null;
      });

    this.documents.certificateNo = paramCertificateNo;
    this.documents.emailOrPhoneOrName = paramEmailOrPhoneOrName;
    // DESC or ASC
    if (this.isFirstLoad === false) {
      if (this.sort.direction === 'asc') {
        this.sortDirection = 'ASC';
      } else if (this.sort.direction === 'desc') {
        this.sortDirection = 'DESC';
      }
    } else {
      this.isFirstLoad = false;
    }
    this.documentMohaService.contractEmploymentPersonalFilter(this.getFilterCondition(page, pageSize, this.documents))
      .subscribe(rs => {
        if (rs.data != null && rs.data.currentPage != null && rs.data.pageSize != null
          && rs.data.totalRow != null) {
          this.paginate = {
            currentPage: rs.data.currentPage,
            pageSize: rs.data.pageSize,
            totalRow: rs.data.totalRow,
            totalPage: Math.ceil(rs.data.totalRow / rs.data.pageSize),
            totalPageArray: this.counter(Math.ceil(rs.data.totalRow / rs.data.pageSize), 1),
            no: this.counter(rs.data.pageSize, rs.data.currentPage * rs.data.pageSize + 1)
          };
        }

        if (rs.data && rs.data.dataRow != null) {
          this.getDisplayedColumns();
          this.initParent(rs);
        }
      });
  }

  initParent(rs: any): void {
    this.parentDocuments = (rs && rs.data && rs.data.dataRow) ? rs.data.dataRow : [];
    const currentPage = (this.paginate && this.paginate.currentPage != null) ? this.paginate.currentPage : 0;
    const pageSize = (this.paginate && this.paginate.pageSize) ? this.paginate.pageSize : 10;
    const from = currentPage * pageSize + 1;
    this.parentDocuments.forEach((item: any, index: number) => {
      item.STT = from + index;
    });
    this.checkCheckAll();
    this.dataSource.setData(this.parentDocuments);
  }

  sortData(sort: Sort) {

    if (!sort.active || sort.direction === '') {
      return;
    }

    this.sortColumn = sort.active;
  }


  /**
   * Filter data with condition
   */
  onFilterData(page: number = 0, pageSize: number = 10) {

    if (this.isFirstLoad === false) {
      if (this.sort.direction === 'asc') {
        this.sortDirection = 'ASC';
      } else if (this.sort.direction === 'desc') {
        this.sortDirection = 'DESC';
      }
    } else {
      this.isFirstLoad = false;
    }
    // set null for document model
    this.oldData.certificateNo = this.oldData.certificateNo || null;
    this.oldData.emailOrPhoneOrName = this.oldData.emailOrPhoneOrName || null;
    this.documentMohaService.contractEmploymentPersonalFilter(this.getFilterCondition(page, pageSize, this.oldData))
      .subscribe(
        rs => {
          this.paginate = {
            currentPage: rs.data.currentPage,
            pageSize: rs.data.pageSize,
            totalRow: rs.data.totalRow,
            totalPage: Math.ceil(rs.data.totalRow / rs.data.pageSize),
            totalPageArray: this.counter(Math.ceil(rs.data.totalRow / rs.data.pageSize), 1),
            no: this.counter(rs.data.pageSize, rs.data.currentPage * rs.data.pageSize + 1)
          };
          this.initParent(rs);
        }
      );
  }

  /**
   * Chuyển tiếp HĐ
   * Forward Contract
   */

  forwardContract(element) {
    const dialogRe = this.dialog.open(ForwardContractDialogComponent, {
      width: '800px',
      data: { data: element },
    });
    dialogRe.afterClosed().subscribe(rs => {
      if (rs) {
        this.toastr.success(this.message.getMessage('messages.notify_sign_contract_user_success'));
      }
    });
  }

  /**
   * Navigate to view detail document
   */
  viewDetail(documentData: any) {
    this.documentMohaService.getPersonalContract(documentData.id).subscribe(res => {
      if (res.success) {
        const data = {
          ...res.data,
          id: documentData.id
        }
        const dialogRe = this.dialog.open(LaborProfileDialogComponent, {
          width: '800px',
          data: data,
        })
        dialogRe.afterClosed().subscribe(rs => {
          if (rs) {

          }
        });
      } else {
        this.toastr.error(res.message)
      }
    });
  }

  /**
   * Open PDF By Browser
   */
  downloadFileEmploye(documentData: any) {
    if (documentData && documentData.id) {
      const employeeName = documentData.fullName || documentData.name || '';
      const profileCount = documentData.totalRecord || documentData.count || 1;

      this.downloadService.setData({
        contractIds: [documentData.id],
        menuContract: EnumDownloadMenuName.VIEW_EMPLOYEE_LIST,
        employeeName: employeeName,
        employeeProfileCount: profileCount
      });
    }
  }

  private getFileName(disposition: string): string {
    if (!disposition) {
      return 'download.zip';
    }

    const utf8Match = /filename\\*=UTF-8''([^;]+)/i.exec(disposition);
    if (utf8Match) {
      return decodeURIComponent(utf8Match[1]);
    }

    const normalMatch = /filename=\"?([^\";]+)\"?/i.exec(disposition);
    return normalMatch ? normalMatch[1] : 'download.zip';
  }
  /**
   * Set params for to navigate
   */
  toNavigate(route, params = {}) {
    let queryParams: any = {
      ...params,
      page: this.paginate.currentPage,
      pageSize: this.paginate.pageSize,
      routeLink: '',
      certificateNo: this.documents.certificateNo,
      emailOrPhoneOrName: this.documents.emailOrPhoneOrName,
      sortColumn: this.sortColumn,
      sortDirection: this.sortDirection
    };
    this.router.navigate([route], { queryParams });
  }
  checkAllCheckBox() {
    this.dataSource.data.value.forEach(data => {
      data.checked = this.checkAll;
      if (data.checked) {
        this.dataSelected.set(data.id, data);
      } else {
        // this.checkAll = false;
        this.dataSelected.delete(data.id);
      }
    });
  }

  public onSelect(element) {
    if (this.dataSource == null
      || this.dataSource.data == null
      || this.dataSource.data.value == null
      || this.dataSource.data.value.length === 0) {
      return;
    }
    if (element.checked) {
      this.dataSelected.set(element.id, element);
    } else {
      this.dataSelected.delete(element.id);
    }
    this.checkCheckAll();
  }

  checkCheckAll() {
    if (this.dataSelected.size === 0) {
      this.checkAll = false;
      return;
    }
    // set data checked when id in select
    this.parentDocuments.forEach(doc => doc.checked = this.dataSelected.has(doc.id));
    this.checkAll = this.parentDocuments.every(doc => this.dataSelected.has(doc.id));
  }

  focusOutCertificateNo() {
    this.documents.certificateNo = this.documents.certificateNo == undefined ? '' : (this.documents.certificateNo + '').trim()
  }
  focusoutEmailOrPhone() {
    this.documents.emailOrPhoneOrName = this.documents.emailOrPhoneOrName == undefined ? '' : (this.documents.emailOrPhoneOrName + '').trim()
  }

  getSex(data: boolean | null | undefined): string {
    if (data === null || data === undefined) {
      return '';
    } else if (data) {
      return this.message.getMessage('form.male');
    } else {
      return this.message.getMessage('form.female');
    }
  }
}

export class Paginate {
  currentPage: number;
  pageSize: number;
  totalRow: number;
  totalPage: number;
  totalPageArray: any;
  no: any;
}

export class Document {
  STT: number;
  name: string; //
  id: string; //
  code: string; //
  createdTime: any;
  createdTimeFrom: string;
  createdTimeTo: string;
  finishDate: string;
  finishDateFrom: string;
  finishDateTo: string;
  createdUser: string;
  customerName: string;
  taxCode: string;
  customerTaxCode: string;
  customerCertificateNo: string;
  customerGroups: CustomerGroup[]; // Nhóm khách hàng
  status: any;
  parentId: string;
  enterprise: string;
  documentType: any;
  serviceType: any;
  email: string;
  hasChildren: boolean;
  nameOrCode: string;
  typeId: any;
  isDifferentEnterprise: boolean;
  signRole: any;
  nameOrEmailOrPhoneUserSign: string;
  checked: boolean;
  submittedByATime: Date;
  expireStatus: string;
  negotiate: any;
  formType: any;
  userSign: any;
  role: any;
  // 1 không được phân quyền ký
  // 2 được phân quyền ký
  // 3 chỉ xem và copy
  // is parent element
  permission: number;

  // DRAFT(0),
  // WAIT_1(1),
  // SINGED_1(2),
  // REJECT_1(3),
  // WAIT_2(4),
  // SINGED_2(5),
  // REJECT_2(6);
  // Finish (7); ?
  // 0 - Nháp
  // 1- Chờ ký bên lập
  // 2 - Đã ký bên lập
  // 3 - Từ chối bên lập
  // 4 - Chờ ký bên nhận
  // 5 - Ký bên nhận
  // 6 - Từ chối bên nhận
  // 7 - HOÀN THÀNH
  // 8 - Mới gởi qua bên nhận
  uuidContractMoha: string;
  mohaStatus: number;
  mohaConfirmStatus: number;

  // hồi sửa lại sau
  getPermission(): void {
    if (this.status === 3 || this.status === 6 // reject
      || this.status === 1 // được ký bởi bên lập
      || this.status === 7) { // Finish
      this.permission = 3;
    } else if (this.status === 1 || this.status === 4) {
      this.permission = 2;
    } else {
      this.permission = 1;
    }
  }
}


export class DocumentDataSource extends DataSource<Document> {
  /** Stream of data that is provided to the table. */
  public data = new BehaviorSubject<Document[]>([]);

  constructor() {
    super();
  }

  setData(data: Document[]) {
    this.data.next(data);
  }

  /** Connect function called by the table to retrieve one stream containing the data to render. */
  connect(): Observable<Document[]> {
    return this.data.asObservable();
  }

  /* disconnect() {} */
  disconnect(): void {
    this.data.complete();
  }
}

/** Create CustomerGroup Type. */
export class CustomerGroup {
  id?: string;
  name?: string;
}
